/**
 * Optimization API Service
 * 
 * Handles all API calls related to optimization runs
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  OPTIMIZATION_RUNS: '/inven_opt/runs',
  OPTIMIZATION_RUN_BY_ID: (id) => `/inven_opt/runs/${id}`,
};

/**
 * Optimization API functions
 */
export const optimizationService = {
  // Get all optimization runs
  getOptimizationRuns: (params) => api.get(ENDPOINTS.OPTIMIZATION_RUNS, { params }),
  
  // Get optimization run by ID
  getOptimizationRunById: async (id) => {
    try {
      const response = await api.get(ENDPOINTS.OPTIMIZATION_RUN_BY_ID(id));
      console.log('Raw API response:', response);
      return response;
    } catch (error) {
      console.error('API error in getOptimizationRunById:', error);
      throw error;
    }
  },
  
  // Create new optimization run
  createOptimizationRun: (data) => api.post(ENDPOINTS.OPTIMIZATION_RUNS, data),
}; 